import React, { FC } from 'react';

export const QualityGatesIcon: FC = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.59828 12.8409C8.1237 12.3663 7.32739 12.4676 7.05191 13.0796C6.37605 14.5811 6 16.2466 6 18C6 24.6274 11.3726 30 18 30C24.6274 30 30 24.6274 30 18C30 11.3726 24.6274 6 18 6C16.2466 6 14.5811 6.37605 13.0796 7.05188C12.4676 7.32737 12.3663 8.12367 12.8409 8.59825C13.1584 8.91572 13.6432 8.98517 14.0557 8.80794C15.2659 8.28797 16.5993 8 18 8C23.5228 8 28 12.4772 28 18C28 23.5228 23.5228 28 18 28C12.4772 28 8 23.5228 8 18C8 16.5993 8.28798 15.2659 8.80796 14.0557C8.98519 13.6432 8.91574 13.1583 8.59828 12.8409Z"
        fill="#90DF52"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2367 19.9941C24.7772 20.5346 25.6878 20.3495 25.8399 19.6004C25.9449 19.0833 26 18.5481 26 18C26 13.5817 22.4183 10 18 10C13.5817 10 10 13.5817 10 18C10 22.4183 13.5817 26 18 26C18.5481 26 19.0832 25.9449 19.6003 25.8399C20.3494 25.6878 20.5345 24.7772 19.9941 24.2367C19.7218 23.9645 19.3261 23.8657 18.9458 23.9259C18.6377 23.9747 18.3218 24 18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18C24 18.3218 23.9747 18.6377 23.9259 18.9458C23.8657 19.3261 23.9645 19.7218 24.2367 19.9941Z"
        fill="#90DF52"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4141 15.7071C21.8046 16.0977 21.8046 16.7308 21.4141 17.1214L17.207 21.3285L14.4999 18.6214C14.1094 18.2308 14.1094 17.5977 14.4999 17.2071C14.8904 16.8166 15.5236 16.8166 15.9141 17.2071L17.207 18.5L19.9999 15.7071C20.3904 15.3166 21.0236 15.3166 21.4141 15.7071Z"
        fill="#90DF52"
      />
    </svg>
  );
};
